import cn from "clsx";
import { slugify } from "design-system/utils/slugify";

export interface ColumnHeaderProps {
  tableId: string;
  columnHeader: string;
  groupHeader?: string;
  index?: number;
  hrRule?: boolean;
}

export function TableColumnHeader({
  tableId,
  columnHeader,
  groupHeader,
  index,
  hrRule = false,
}: ColumnHeaderProps) {
  return (
    <th
      id={slugify(cn(columnHeader, tableId, groupHeader))}
      scope="col"
      data-index={index}
      className={hrRule ? "hbs-table-cell-hr-rule" : ""}
    >
      {columnHeader}
    </th>
  );
}
